import { path } from 'ramda';

export const popularJobTitleSalaryDistributionBoxSelector = path([
  'popularJobTitleSalaryDistribution',
]);
